import React from 'react';
import { TrendingUp } from 'lucide-react';
import { usersIconAssets, exchangeIconAssets, checkIconAssets, loaderIconAssets } from '@/assets/images';

export interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle: string;
  iconType: 'users' | 'clock' | 'check' | 'file';
}

const UsersIcon: React.FC = () => (
  <div className="relative shrink-0 size-[22px]">
    <div className="absolute inset-0">
      <img alt="" className="block max-w-none size-full" src={usersIconAssets.base} />
    </div>
    <div className="absolute inset-[12.5%_45.83%_54.17%_20.83%]">
      <div className="absolute inset-[-9.375%]" style={{ "--stroke-0": "rgba(47, 43, 61, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={usersIconAssets.oval} />
      </div>
    </div>
    <div className="absolute inset-[62.5%_37.5%_12.5%_12.5%]">
      <div className="absolute inset-[-12.5%_-6.25%]" style={{ "--stroke-0": "rgba(0, 131, 202, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={usersIconAssets.path1} />
      </div>
    </div>
    <div className="absolute inset-[13.04%_20.8%_54.67%_66.67%]">
      <div className="absolute inset-[-9.68%_-24.93%_-9.68%_-24.94%]" style={{ "--stroke-0": "rgba(47, 43, 61, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={usersIconAssets.path2} />
      </div>
    </div>
    <div className="absolute bottom-[12.5%] left-3/4 right-[12.5%] top-[63.13%]">
      <div className="absolute inset-[-12.82%_-25%_-12.82%_-25.01%]" style={{ "--stroke-0": "rgba(47, 43, 61, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={usersIconAssets.path3} />
      </div>
    </div>
  </div>
);

const ExchangeIcon: React.FC = () => (
  <div className="relative shrink-0 size-[22px]">
    <div className="absolute inset-0">
      <img alt="" className="block max-w-none size-full" src={exchangeIconAssets.base} />
    </div>
    <div className="absolute inset-[66.67%_70.83%_16.67%_12.5%]">
      <div className="absolute inset-[-20.454%]" style={{ "--stroke-0": "rgba(255, 76, 81, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={exchangeIconAssets.icon1} />
      </div>
    </div>
    <div className="absolute inset-[16.67%_12.5%_66.67%_70.83%]">
      <div className="absolute inset-[-20.45%]" style={{ "--stroke-0": "rgba(255, 76, 81, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={exchangeIconAssets.icon2} />
      </div>
    </div>
    <div className="absolute inset-[33.33%_20.83%_12.5%_45.83%]">
      <div className="absolute inset-[-6.29%_-10.23%]" style={{ "--stroke-0": "rgba(255, 76, 81, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={exchangeIconAssets.icon3} />
      </div>
    </div>
    <div className="absolute inset-[12.5%_45.83%_33.33%_20.83%]">
      <div className="absolute inset-[-6.29%_-10.23%]" style={{ "--stroke-0": "rgba(255, 76, 81, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={exchangeIconAssets.icon4} />
      </div>
    </div>
  </div>
);

const CheckIcon: React.FC = () => (
  <div className="relative shrink-0 size-[22px]">
    <div className="absolute inset-0">
      <img alt="" className="block max-w-none size-full" src={checkIconAssets.base} />
    </div>
    <div className="absolute inset-[29.17%_16.67%_29.17%_20.83%]">
      <div className="absolute inset-[-8.18%_-5.45%]" style={{ "--stroke-0": "rgba(40, 199, 111, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={checkIconAssets.icon1} />
      </div>
    </div>
  </div>
);

const LoaderIcon: React.FC = () => (
  <div className="relative shrink-0 size-[22px]">
    <div className="absolute inset-0">
      <img alt="" className="block max-w-none size-full" src={loaderIconAssets.base} />
    </div>
    <div className="absolute bottom-3/4 left-[47.92%] right-[47.92%] top-[12.5%]">
      <div className="absolute inset-[-27.27%_-31.82%]" style={{ "--stroke-0": "rgba(255, 159, 67, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={loaderIconAssets.icon1} />
      </div>
    </div>
    <div className="absolute inset-[23.33%_23.33%_67.71%_67.71%]">
      <div className="absolute inset-[-38.055%]" style={{ "--stroke-0": "rgba(255, 159, 67, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={loaderIconAssets.icon2} />
      </div>
    </div>
    <div className="absolute bottom-[47.92%] left-3/4 right-[12.5%] top-[47.92%]">
      <div className="absolute inset-[-31.82%_-27.27%]" style={{ "--stroke-0": "rgba(255, 159, 67, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={loaderIconAssets.icon3} />
      </div>
    </div>
    <div className="absolute inset-[67.71%_23.33%_23.33%_67.71%]">
      <div className="absolute inset-[-38.055%]" style={{ "--stroke-0": "rgba(255, 159, 67, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={loaderIconAssets.icon4} />
      </div>
    </div>
    <div className="absolute bottom-[12.5%] left-[47.92%] right-[47.92%] top-3/4">
      <div className="absolute inset-[-27.27%_-31.82%]" style={{ "--stroke-0": "rgba(255, 159, 67, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={loaderIconAssets.icon5} />
      </div>
    </div>
    <div className="absolute inset-[67.71%_67.71%_23.33%_23.33%]">
      <div className="absolute inset-[-38.055%]" style={{ "--stroke-0": "rgba(255, 159, 67, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={loaderIconAssets.icon6} />
      </div>
    </div>
    <div className="absolute bottom-[47.92%] left-[12.5%] right-3/4 top-[47.92%]">
      <div className="absolute inset-[-31.82%_-27.27%]" style={{ "--stroke-0": "rgba(255, 159, 67, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={loaderIconAssets.icon7} />
      </div>
    </div>
    <div className="absolute inset-[23.33%_67.71%_67.71%_23.33%]">
      <div className="absolute inset-[-38.055%]" style={{ "--stroke-0": "rgba(255, 159, 67, 1)" } as React.CSSProperties}>
        <img alt="" className="block max-w-none size-full" src={loaderIconAssets.icon8} />
      </div>
    </div>
  </div>
);

export const MetricCard: React.FC<MetricCardProps> = ({ title, value, subtitle, iconType }) => {
  const getIconConfig = (type: MetricCardProps['iconType']) => {
    switch (type) {
      case 'users':
        return {
          bgColor: 'bg-[rgba(0,131,202,0.16)]',
          icon: <UsersIcon />
        };
      case 'clock':
        return {
          bgColor: 'bg-[rgba(255,76,81,0.16)]',
          icon: <ExchangeIcon />
        };
      case 'check':
        return {
          bgColor: 'bg-[rgba(40,199,111,0.16)]',
          icon: <CheckIcon />
        };
      case 'file':
        return {
          bgColor: 'bg-[rgba(255,159,67,0.16)]',
          icon: <LoaderIcon />
        };
      default:
        return {
          bgColor: 'bg-[rgba(0,131,202,0.16)]',
          icon: <UsersIcon />
        };
    }
  };

  const iconConfig = getIconConfig(iconType);

  return (
    <div className="bg-white box-border content-stretch flex flex-col items-start relative rounded-[6px] shadow-[0px_3px_12px_0px_rgba(47,43,61,0.14)] size-full">
      <div className="box-border content-stretch flex gap-px items-center p-[24px] relative shrink-0 w-full">
        <div className="basis-0 content-stretch flex flex-col gap-[4px] grow items-start min-h-px min-w-px relative shrink-0">
          <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full">
            <div className="basis-0 flex flex-col font-['Roboto'] font-normal grow justify-center leading-[0] min-h-px min-w-px relative shrink-0 text-[var(--color-text-primary)] text-[16px] tracking-[0.5px]" style={{ fontVariationSettings: "'wdth' 100" }}>
              <p className="leading-[24px]">{title}</p>
            </div>
            <div className="content-stretch flex flex-col items-center relative shrink-0">
              <div className={`${iconConfig.bgColor} box-border content-stretch flex items-center p-[8px] relative rounded-[6px] shrink-0`}>
                {iconConfig.icon}
              </div>
            </div>
          </div>
          <div className="flex flex-col font-['Roboto'] font-medium justify-center leading-[0] min-w-full relative shrink-0 text-[var(--color-text-primary)] text-[32px]" style={{ width: "min-content", fontVariationSettings: "'wdth' 100" }}>
            <p className="leading-[40px]">{value}</p>
          </div>
          <div className="content-stretch flex gap-[6px] items-center relative shrink-0">
            <TrendingUp className="w-4 h-4 text-green-600" />
            <div className="font-['Roboto'] font-normal leading-[0] relative shrink-0 text-[var(--color-text-primary)] text-[12px] text-nowrap tracking-[0.4px]" style={{ fontVariationSettings: "'wdth' 100" }}>
              <p className="leading-[16px] whitespace-pre">{subtitle}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
